export class Locations {
    constructor(parentElement) {
        this.activeClass = 'is-active';
        this.hiddenClass = 'is-hidden';

        this.buttons = Array.from(parentElement.getElementsByClassName('js-locations-button'));
        this.markers = Array.from(parentElement.getElementsByClassName('js-locations-marker'));
        this.cards = Array.from(parentElement.getElementsByClassName('js-locations-card'));
        this.cardsWrapper = parentElement.querySelector('.js-locations-cards');
        this.ctaButton = parentElement.querySelector('.js-locations-cta-button');

        // Get location data from data attribute
        this.locationLinks = JSON.parse(parentElement.dataset.locationLinks || '[]');

        this.buttons.forEach((item) => {
            item.addEventListener('click', (event) => this.handleClick(event));
        });

        this.markers.forEach((marker) => {
            marker.addEventListener('click', (event) => this.handleClick(event));
        });

        // Check if there's a default active location (for NL site)
        const defaultActiveButton = this.buttons.find(button => button.hasAttribute('data-default-active'));
        const defaultActiveId = defaultActiveButton ? defaultActiveButton.dataset.locationId : null;

        // Use default active location if available, otherwise use random
        const activeId = defaultActiveId || this.cards[Math.floor(Math.random() * this.cards.length)].dataset.locationId;

        this.setActiveButton(activeId);
        this.setActiveMarker(activeId);
        this.setActiveCard(activeId);
        this.updateCtaLink(activeId);
    }

    handleClick(event) {
        const target = event.target;
        const clickLocationId = target.dataset.locationId;
        this.setActiveButton(clickLocationId);
        this.setActiveMarker(clickLocationId);
        this.setActiveCard(clickLocationId);
        this.updateCtaLink(clickLocationId);
        this.scrollToCards();
    }

    setActiveButton(buttonId) {
        this.buttons.forEach((button) => button.classList.toggle(this.activeClass, button.dataset.locationId === buttonId));
    }

    setActiveMarker(markerId) {
        this.markers.forEach((marker) => marker.classList.toggle(this.activeClass, marker.dataset.locationId === markerId));
    }

    setActiveCard(cardId) {
        this.cards.forEach((card) => card.classList.toggle(this.hiddenClass, card.dataset.locationId !== cardId));
    }

    scrollToCards() {
        this.cardsWrapper.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }

    updateCtaLink(locationId) {
        if (!this.ctaButton) return;

        const locationData = this.locationLinks.find(loc => loc.id === parseInt(locationId));
        if (locationData && locationData.link) {
            this.ctaButton.href = locationData.link;
        }
    }
}